import axios from 'axios'

const UserService = {
  /**
   * Retrieve data based on the provided parameters
   * @async
   * @param {Object} params - Query parameters to filter data
   * @param {number} params.page - Name of the cluster to search for
   * @param {number} params.per_page - Number of data per page
   * @param {string} params.sort - Sort by field (e.g., 'name', 'created_at')
   * @param {boolean} params.sort_desc - Sorting if descending (e.g., 'true' or 'false')
   * @param {string} params.filter_text - Text to filter data by name
   * @returns {Promise<Object>} The API response containing data
   */
  async get (params = {}) {
    return axios.get('admin/users', { params })
  },

  async show (id) {
    return axios.get(`admin/users/${id}`)
  },

  async post (params = {}) {
    return axios.post('admin/users', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/users/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/users/${data.id}`, { data })
  }
}

export default UserService
